import React from 'react';
import { ReactComponent as CloudError } from 'assets/images/cloud-error.svg';
import { FlightButton } from '@flybits/design-system';

import './AnalyticsErrorState.scss';

const CLASS_MAIN = 'analytics-error-state';
const CLASSES = {
  ROOT: CLASS_MAIN,
  ROOT_COMPACT: `${CLASS_MAIN} ${CLASS_MAIN}--compact`,
  IMAGE: `${CLASS_MAIN}__image`,
  TITLE: `${CLASS_MAIN}__title`,
  DESCRIPTION: `${CLASS_MAIN}__description`,
  RETRY: `${CLASS_MAIN}__retry`,
};

const DEFAULT_TITLE = 'Unable to load analytics';
const DEFAULT_DESCRIPTION =
  "We're sorry, there was a problem loading the data. Please try again.";

export type AnalyticsErrorStateProps = {
  onRetry: () => void;
  isRetrying?: boolean;
  title?: string;
  description?: string;
  compact?: boolean;
};

const AnalyticsErrorState = ({
  onRetry,
  isRetrying = false,
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  compact = false,
}: AnalyticsErrorStateProps) => {
  const rootClass = compact ? CLASSES.ROOT_COMPACT : CLASSES.ROOT;

  return (
    <div className={rootClass}>
      <CloudError className={CLASSES.IMAGE} />
      <div className={CLASSES.TITLE}>{title}</div>
      <div className={CLASSES.DESCRIPTION}>{description}</div>
      <FlightButton
        className={CLASSES.RETRY}
        iconLeft="replay"
        label="Retry"
        onClick={onRetry}
        size="small"
        disabled={isRetrying}
      />
    </div>
  );
};

export default AnalyticsErrorState;
